<template>
  <modal
    :name="modalName"
    :adaptive="true"
    height="auto"
    width="500px"
    scrollable
    reset
    @closed="clearUrlQuery"
  >
    <div class="v-modal__inner">
      <div
        v-if="slotContent"
        v-html="slotContent"
      />
      <slot v-else />
      <span
        role="button"
        aria-label="Close popup"
        class="v-modal__button--close"
        @click="hideModal"
      />
    </div>
  </modal>
</template>

<script>
import { onMounted } from '@vue/composition-api'
import { getQueryParam, deleteSearchParam } from '@/Redesign/Helpers/url'
export default {
  props: {
    redirectName: {
      type: String,
      required: true
    },
    slotContent: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const queryParamName = 'open-modal'
    const { $modal } = context.parent
    const modalName = `modal-redirect-${props.redirectName}`
    const redirectName = getQueryParam(queryParamName)

    const showModal = () => {
      $modal.show(modalName)
    }

    const clearUrlQuery = () => {
      deleteSearchParam(queryParamName)
    }

    const hideModal = () => {
      $modal.hide(modalName)
    }

    onMounted(() => {
      if (redirectName === props.redirectName) {
        showModal()
      }
    })

    return {
      modalName,

      hideModal,
      clearUrlQuery
    }
  }
}
</script>
